import { FC } from 'react';
import { Spinner } from 'dibs-elements/exports/Spinner';
import classnames from 'classnames';

import styles from './styles/AuctionBiddingModalSpinner.scss';

const AuctionBiddingModalSpinner: FC<{ size?: 'small' | 'medium' }> = ({ size = 'medium' }) => {
    return (
        <div className={classnames(styles.wrapper, styles[size])}>
            <Spinner containerClass={classnames(styles.spinner, styles[size])} />
        </div>
    );
};

export default AuctionBiddingModalSpinner;
